export interface QueryType {
    name: string;
    dataEndpoint: string;
    metadataEndpoint: string;
    statusEndpoint: string;
}

export interface QueryPeriodType {
    id: number;
    name: string;
}

export const enum QueryPeriodTypeName {
    RANGE_WITH_ACTIVE_DATE = 'Range with Active Date',
    RANGE = 'Range',
    POINT_IN_TIME = 'Point in Time',
    NO_CALENDAR = 'No Calendar',
}

export const enum QueryTypeName {
    AD_HOC = 'AdHoc',
    CASH_PROJECTION = 'CashProjection',
    CHECKLIST = 'Checklist',
    ECDI = 'InvestorsEconomicDistribution',
    EOD = 'EOD',
    GQL = 'GQL',
    INSTRUMENT= 'Instrument',
    INVESTORS_ACTIVITY = 'InvestorsActivity',
    INVESTORS_PERFORMANCE = 'InvestorsPerformance',
    INVESTORS_ASSETS = 'InvestorsAssets',
    INVESTORS_FUNDS_ASSETS = 'InvestorsFundsAssets',
    PORTFOLIO = 'Portfolio',
    POSITIONS = 'Positions',
    RECON = 'Recon',
    SETTLEMENT_BREAKS = 'SettlementBreaks',
    SNOWFLAKE = 'Snowflake',
    TAX = 'DynamicTaxReporting',
    TFL_INCOMPLETE_FILES = 'TFLIncompleteFiles',
    TRADE_FILE_DETAILS = 'TradeFileDetails',
    TRADE_FILE_LOADER = 'TradeFileLoader',
    TRADE_FILE_SUMMARY = 'TradeFileSummary',
    TRADES = 'Trades',
    TRANSACTIONS = 'Transactions'
}

const investorQueryTypeNames: QueryTypeName[] = [
    QueryTypeName.INVESTORS_ACTIVITY,
    QueryTypeName.INVESTORS_ASSETS,
    QueryTypeName.INVESTORS_FUNDS_ASSETS,
    QueryTypeName.INVESTORS_PERFORMANCE,
    QueryTypeName.ECDI,
];

export function isInvestorQueryType(queryType: string | undefined): boolean {
    return investorQueryTypeNames.includes(queryType as QueryTypeName);
}
